export default "__VITE_ASSET__05tMVvt5__"